"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@linaria/core");
var _intents = _interopRequireDefault(require("@ux/intents"));
const intents = new _intents.default();
"cpa2b0d";
const cardHeaderStyle = "c1gptk5a";
var _default = exports.default = cardHeaderStyle;